<!-- views/chatgpt.vue -->

<template>
  <div class="common-layout">
    <div class="chat-content" ref="chat">
      <!-- recordContent 聊天记录数组-->
      <div v-for="(itemc, indexc) in chatRecord" :key="indexc">
        <!-- 对方 -->
        <div class="word" v-if="!itemc.mineMsg">
          <i @click="chat" class="iconfont icon-robot-img" :class="iconClass"></i>
          <div class="info">
            <div class="info-content markdown-body" :class="{
              loading: !itemc.message
            }" v-html="itemc.message || '|'"></div>
          </div>
        </div>
        <!-- 我的 -->
        <div class="word-my" v-else>
          <div class="info-content">{{ itemc.message }}</div>
          <!-- <img :src="itemc.headUrl"> -->
          <i @click="chat" class="iconfont icon-xiaolian" :class="iconClass1"></i>
        </div>
      </div>
    </div>
    <div class="enter">
      <input v-model="question" type="text" placeholder="请输入您的问题" style="width: 100% !important;" @keydown.enter="chat">
      <i @click="chat" class="iconfont icon-huiche"></i>
    </div>
  </div>

</template>

<script>
import markdownit from 'markdown-it'
import 'github-markdown-css'
export default {
  name: 'Reply',
  data() {
    return {
      question: '',
      count: 0,
      click: false,
      chatRecord: [{ sender: '小助手 :', message: '您好！有什么需要向我提问的吗？', mineMsg: false }],
      assistantHis: [],
      timer: null,
      answerStream: [],
      answerPos: 0,
      chatAI: {
        sender: undefined,
        message: undefined,
        mineMsg: false
      }
    }
  },
  computed: {
    theme() {
      return 'grey'
    },
    iconClass() {
      return {
        grey: this.theme === 'grey'
      }
    },
    iconClass1() {
      return {
        grey: this.theme === 'grey',
        black: this.theme === 'black'
      }
    }
  },
  created: function () {
    // this.getFamilyBase_info()
    // 每次进入界面时，先清除之前的所有定时器，然后启动新的定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  destroyed: function () {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    setTimer() {
      this.time && clearInterval(this.timer)
      this.timer = null
      if (this.timer == null) {
        this.timer = setInterval(() => {
          if (this.answerStream.length && this.answerPos < this.answerStream.length) {
            if (this.answerStream[this.answerPos] !== undefined) {
              // const md = markdownit()
              // const result = md.render(this.answerStream[this.answerPos].answer)
              this.chatAI.message = this.chatAI.message + this.answerStream[this.answerPos]
              this.$refs.chat.scrollTo({
                top: this.$refs.chat.scrollHeight,
                behavior: 'smooth'
              })
            }
            this.answerPos = this.answerPos + 1
          } else {
            this.time && clearInterval(this.timer)
            this.timer = null
          }
        }, 500)
      }
    },

    chat() {
      if (this.question && (this.answerStream.length === this.answerPos || this.answerPos === 0)) {
        const you = { sender: '我:', message: this.question, mineMsg: true }
        this.chatAI = { sender: '小助手:', message: '', mineMsg: false }
        this.chatRecord.push(you)
        this.chatRecord.push(this.chatAI)
        this.$refs.chat.scrollTo({
          top: this.$refs.chat.scrollHeight,
          behavior: 'smooth'
        })
        const data = this.question
        this.question = ''
        if (this.assistantHis.length > 20) {
          this.assistantHis.shift()
          this.assistantHis.shift()
        }
        this.$axios.post(this.$apis.common.getAnswerApiSimple, {
          text: data,
          stream: true,
          his: this.assistantHis
        }).then(response => {
          this.answerPos = 0
          // const answerStream = JSON.parse(response)
          this.answerStream = JSON.parse(response)
          const answer = this.answerStream.map(item => {
            return item.answer || ''
          })
          this.$refs.chat.scrollTo({
            top: this.$refs.chat.scrollHeight,
            behavior: 'smooth'
          })
          const md = markdownit()
          const result = md.render(answer.join(''))
          // const list = result.split(/(<[^>]+>)/)
          const list = this.splitIntoChunks(result)
          this.answerStream = list
          this.assistantHis.push({ role: 'user', content: data })
          this.assistantHis.push({ role: 'assistant', content: answer.join('') })
          this.setTimer()
        })
      }
    },
    splitIntoChunks(html) {
      // 这里我们通过按段落拆分HTML内容
      // 你可以根据需求，拆分为更小的块，如按 <ul>、<li>、<p> 等标签
      const parser = new DOMParser()
      const doc = parser.parseFromString(html, 'text/html')
      const elements = Array.from(doc.body.childNodes)
      return elements.map(el => el.outerHTML || el.textContent) // 获取完整的HTML块
    },
    extractChunks(element, chunks) {
      if (element.nodeType === Node.ELEMENT_NODE) {
        chunks.push(element.outerHTML) // 保存当前元素的完整HTML
        // 递归提取子元素
        for (const child of element.childNodes) {
          this.extractChunks(child, chunks)
        }
      } else if (element.nodeType === Node.TEXT_NODE && element.textContent.trim()) {
        chunks.push(element.textContent) // 仅处理非空文本节点
      }
    }
  }
}
</script>

<style scoped lang="scss">
.common-layout {
  user-select: text;
}

.chat-content {
  position: relative;
  height: 550px;
  color: var(--header-bar-title-color);
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 12px;
  padding-bottom: 40px;
  margin-bottom: 20px;
  overflow: auto;

  .word {
    display: flex;
    align-items: flex-start;
    min-height: 43px;
    border: 1px solid var(--help-message-border-color);
    background: var(--help-message-bg);
    border-radius: 4px;
    margin-bottom: 20px;
    padding: 17px 10px;
    line-height: 20px;

    i {
      font-size: 26px;
    }

    .grey {
      color: #165EFF;
    }

    .info {
      margin-left: 15px;
      word-break: break-word;

      .loading {
        animation: blink 1.7s infinite;
      }

      .markdown-body {
        padding: 5px;
        background-color: transparent;
        color: #000000;
        min-height: auto !important;
      }
    }
  }

  .word-my {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;

    i {
      font-size: 26px;
    }

    .black {
      color: #FFDEDE;
    }

    .grey {
      color: #FF6C6C;
    }

    .info-content {
      margin-right: 10px;
      word-break: break-word;
    }
  }
}

.enter {
  position: absolute;
  bottom: 17px;
  width: 1060px;
  height: 36px;
  border-radius: 4px;

  i {
    position: absolute;
    right: 20px;
    top: 12px;
    font-size: 12px;
    cursor: pointer;
  }
}

input {
  outline: none;
  display: flex;
  align-items: center;
  width: 100% !important;
  height: 36px !important;
  background: #F4F7FA !important;
  color: #000000 !important;
  border-color: #EAEEF5 !important;
  border: 1px solid;
  line-height: 36px !important;
  padding: 0 49px 0 19px !important;

  &::placeholder {
    color: #000000 !important;
  }
}

// ::v-deep {
//   .el-input {
//     width: 100% !important;
//   }
// }
@keyframes blink {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
</style>
